<template>

    <v-navigation-drawer
        v-model="drawer" 
        right
        app
        style="height: 100vh;"
        :width="260"
        >

        <div style="display: fixed;margin-top: 64px;">
            <div>
            <v-btn
                small
                outlined
                @click="drawer_Btn"
                class="drawer_btn"
                style="min-width: 20px;padding: 2px;height: 40px;border-radius: 6px 0px 0px 6px;"
                >
                <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
        </div>
        
        <v-list-item>
            <v-list-item-content>
            <v-list-item-title><h3>{{ $store.getters.t('원본 영상') }}</h3></v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item>
        <div class="imageInfo-container">
            <v-img :src="getImage" style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;" :contain="true">
                <div class="overlay">
                    <v-icon v-if="stateCheck" style="font-size: 50px;" @click="openPlayer">mdi-play-circle</v-icon>
                </div>
                <div class="overlay_wrap" v-if="codecCheck()" >
                    <div class="overlay">
                        <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
                        <span style="color: #ffffff;font-size:12px">{{ $store.getters.t('인코딩 후 영상 재생이 가능합니다.') }}</span>
                    </div>
                </div>
            </v-img>
        </div>
        </v-list-item>

        <v-list-item>
            <v-list-item-content>
            <v-list-item-title><h3>{{ $store.getters.t('영상 상세 정보') }}</h3></v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <div class="ml-4">
            <table style="width: 92%; table-layout: fixed;border-top: 1px solid #000;">
                <thead>
                <tr class="table_wrap">
                    <th class="text-left table_title pa-3"
                    style="
                    color: #000;
                    font-size: 14px;"
                    >
                        {{ $store.getters.t('이름') }}
                    </th>
                    <th class="text-left table_text pa-3"
                    style="
                    font-size: 14px;
                    font-weight:400;
                    ">
                        <span class="text_box" >{{ assetInfo.name }}</span>
                    </th>
                </tr>
            </thead>
            </table>
            
        </div>

        <v-simple-table class="pa-4 pt-0">
    <template>
        <thead>
            <tr class="table_wrap">
                <th class="text-left table_title pa-3"
                style="
                color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('재생시간') }}
                </th>
                <th class="text-left table_text"
                style="
                font-size: 14px;
                font-weight:400;">
                    <span> {{ assetInfo.runtime }}</span>
                </th>
                
            </tr>
                
            <tr>
                <th class="text-left table_title pa-3"
                style="color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('원본 해상도') }}
                </th>
                <th class="text-left table_text"
                style="font-size: 14px;
                font-weight:400;">
                    <span> {{ assetInfo.upload_resolution }}</span>
                </th>
            </tr>

            <tr>
                <th class="text-left table_title pa-3"
                style="color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('등록일') }}
                </th>
                <th class="text-left table_text"
                style="font-size: 14px;
                font-weight:400;">
                    <span> {{ assetInfo.upload_time }}</span>
                </th>
            </tr>
            <tr>
                <th class="text-left table_title pa-3"
                style="color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('인코딩') }}
                    <v-btn icon :disabled="showBtn" color="#000" size="20px" @click="plusBtn">
                        <v-icon small>mdi-plus-circle</v-icon>
                    </v-btn>
                </th>
                <th class="text-left table_text pa-3 pr-0"
                style="font-size: 14px;
                font-weight:400;">
                    <v-row  v-for="(chip, index) in chipList" :key="index">
                        <v-col cols="9">
                            <div>
                                <v-icon :color="chip.color" small class="mr-1">{{ getIcon(index) }}</v-icon>
                                <Chips  :chipText="chip.text" :ChipsColor="chip.color" />
                            </div>
                            <div class="bitrate_text mt-1">
                                <span style="font-size: 12px;">{{ chip.resolution }}{{ chip.size ? ' [' + chip.size + ']' : '' }}</span>
                            </div>
                        </v-col>
                        <v-col cols="1">
                            <v-btn x-small icon v-if="chip.size !== ''">
                                <v-icon small @click="deleteFile(chip)">mdi-trash-can-outline</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </th> 
            </tr>
            <tr class="table_wrap">
                <th class="text-left table_title pa-3"
                style="
                color: #000;
                font-size: 14px;
                width: 300px;">
                    {{ $store.getters.t('퍼블리싱') }}
                </th>
                <th class="text-left table_text"
                style="
                font-size: 14px;
                font-weight:400;">
                    <CustomSwitch :switchState="switchState" :toggleSwitch="toggleSwitch"/>
                </th>
            </tr>
            <tr class="table_wrap">
                <th class="text-left table_title pa-3"
                style="
                color: #000;
                font-size: 14px;
                width: 300px;">
                    {{ $store.getters.t('보안') }}
                </th>
                <th class="text-left table_text"
                style="
                font-size: 14px;
                font-weight:400;">
                    <v-chip small v-if="assetInfo.secure" class="success_chip">ON</v-chip>
                    <v-chip small v-else disabled>OFF</v-chip>
                </th>
            </tr>
            <tr>
                <th class="text-left table_title pa-3"
                style="border-bottom: 1px solid rgb(0, 0, 0);
                color: #000;
                font-size: 14px;">
                    {{ $store.getters.t('상세보기') }}
                </th>
                <th class="text-left table_line"
                style="border-bottom: 1px solid rgb(0, 0, 0);
                font-size: 14px;
                font-weight:400;">
                    <IconTextButtonoutline :buttonText="$store.getters.t('보기')" :buttonClick="editClick" :isDisabled="!isExists"/>
                </th>
            </tr>
        </thead>
    </template>
</v-simple-table>
</div>

        
<AppSnackbar :snackbarText="snackbarText" :showSnackbar="showSnackbar" :timeout="timeout"></AppSnackbar>
            

</v-navigation-drawer>



</template>

<script>
import Chips from '@/components/ui/chips/Chips.vue';
import IconTextButtonoutline from '@/components/ui/button/IconTextButton_outline.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import { mapState, mapActions } from 'vuex';
import AppSnackbar from '../app/AppSnackbar.vue';
export default {
    components: {
        Chips,
        IconTextButtonoutline,
        CustomSwitch,
        AppSnackbar
    },
    props: {
        drawer: Boolean
    },
    data(){
        return {
            res: [],
            snackbarText: null,
            showSnackbar: false,
            snackbarErrorText: null,
            showSnackbarError: false,
            timeout: null,
            stateCheck: false,
            reqCheck: '',
            checkStatusVal: '',
            check: this.$store.getters['objectData/getStandard']('checkData'),
            chipList: [],
        }
    },
    watch: {
       assetInfo: {
        handler(newVal, oldVal) {
            if(newVal && newVal != oldVal){
               this.chipList = this.getChipData();
            //    console.log("chipList : ", this.chipList)
            }
        },
      }
    },
    mounted() {
        if(this.assetInfo){
            this.chipList = this.getChipData();
        } 
       
    },
    computed: {
         ...mapState('asset', ['assetInfo', 'switchState']),
        getImage(){
            return this.assetInfo.image ?? "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png";
        },
        isExists() {
            if(this.assetInfo.status === "abnormal" || this.assetInfo.status === "extract"){
                return false;
            } else {
                return true;
            }
        },
        // chipList(){
        //     if(this.assetInfo){
        //         return this.getChipData();
        //     } else {
        //         return null;
        //     }
        // },
        showBtn(){
            if(this.assetInfo){
                if(this.reqCheck === 'yes' || this.assetInfo.status !== 'uploaded'){
                    return true;   // 비활성
                } else {
                    return false;  // 활성
                }
            }
        },
       
    },
    methods: {
         ...mapActions('asset', ['updateDistribution', 'checkEncoding']),
        drawer_Btn(){
            this.$emit('close-drawer');
            // this.closeBtn();
        },
        codecCheck(){
            if(this.assetInfo.upload_v_codec !== 'h264' && (this.assetInfo.status === 'uploaded' || this.assetInfo.status === 'processing')){
                return true;
            } else if((this.assetInfo.status === 'h264' || this.assetInfo.status !== 'h264') && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('encoded'))){
                return false;
            }
        },
        getIcon() {
            return (index) => {
                switch(index) {
                case '1080p':
                case 0:
                    return 'mdi-monitor';
                case '720p':
                case 1:
                    return 'mdi-tablet';
                case '480p':
                case 2:
                    return 'mdi-cellphone';
                default:
                    return '';
                }
            }
        },
        deleteFile(index){
            this.$emit('delete-encodeFile', index.id);
        },
        async toggleSwitch(){
            if(this.assetInfo){
                const newState = !this.switchState;

                const params = {
                    id: this.assetInfo.assetId,
                    aid: this.assetInfo.aid,
                    type: this.switchState ? 'unpub' : 'pub',
                    smil_url: this.assetInfo.smil_url,
                    newState: newState,
                    folder: this.checkStatusVal,
                };
                this.$store.commit('asset/setSwitchState', newState);
                const res = await this.updateDistribution(params);
                this.timeout = 2000;
                if(res !== 1){
                    this.$store.commit('asset/setSwitchState', !newState);
                }
                this.$emit('close-drawer');
                this.$emit('reload-data'); 
            }
        },
        editClick() {
            this.$emit('move-edit');
        },
        getChipData() {
            if(this.assetInfo){
                
                const ispub = this.assetInfo.encoding_status ;
                
                this.checkStatusVal = this.assetInfo.status;

                /*
                    # 재생조건
                        . uploaded & encoded 상관없음
                        . h264 코덱
                        . h264 코덱이 아니여도 status가 encoded이면 됨
                        
                        위의 3가지 조건은 encoding_status가 published이면서 status가 processing이 아니여야함
                */
                const a = this.assetInfo.encoding_status === 'Published' && this.assetInfo.status !== 'processing';
                const b = this.assetInfo.upload_v_codec === 'h264' && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('uploaded'));
                const c = this.assetInfo.upload_v_codec !== 'h264' && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('encoded'));
                const d = this.assetInfo.upload_v_codec === 'h264' && (this.assetInfo && this.assetInfo.status && this.assetInfo.status.includes('encoded'));

                this.stateCheck = false;
                if(a){
                    if(b){
                        this.stateCheck = true;
                    }
                    if(c){
                        this.stateCheck = true;
                    }
                    if(d){
                        this.stateCheck = true;
                    }
                } else {
                    this.stateCheck = false;
                }


                let status;
                if (ispub === 'Published') {
                    status = true;
                } 
                else {
                    status = false;
                }
                this.$store.commit('asset/setSwitchState', status);

                let res = [];
             
                const datas = this.assetInfo.encodingInfo;
                if(datas){
                    res = datas.map(e => ({
                        id: e.id,
                        text: e.type !== null && e.type !== undefined ? this.updateType(e.type) : '',
                        color: e.status === 'encoded' ? 'black' : e.status,
                        size: e.size ? e.size : '',
                        resolution: e.resolution ? e.resolution : '',
                    }));
                }

                this.res = res;

                return this.res;
            }
        },
        updateType(val) {
            return val.toString().split(" ")[0];
        },
        async fetchReqCheck(){
            if(this.assetInfo){
                const params = {
                    asset_id: this.assetInfo.assetId
                }
                this.reqCheck = await this.checkEncoding(params);
            }
        },
        openPlayer(){
            this.$emit('play-video');
        },
        plusBtn(){
            this.$emit('check-click');
        },  

        
    },
}
</script>

<style>
.drawer_btn { position: absolute;margin: 30px 0px 0px -28px;background: #fff;border: 1px solid;border-color: #ddd #fff #ddd #ddd; }
.v-navigation-drawer { overflow: visible; }
.imageInfo-container {
    position: relative; 
    background-color: black;
    width: 230px;
    height: 130px;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    overflow: hidden;
    border-radius: 8px;
}
.imageInfo {
    position: absolute;
    height: 100%;
    top: 0;
    object-fit: contain;
    object-position: top center;
    padding: 0;
}
.text-left {
    width:100px !important;
}
.overlay_wrap{
    width: 100%;
    height: 100%;
    background: rgba(255, 74, 74, 0.4);
}
.overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  width:100%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.overlay v-icon {
  font-size: 48px;
  color: white;
  cursor: pointer;
}

.success_chip {
    background: #efffe4 !important;
    color: green !important;
}
</style>